import jsPDF from "jspdf";
import "jspdf-autotable";
import React from "react";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Credit Analysis Report", 40, yPos);
    yPos += 40;

    // Customer Profile
    doc.setFontSize(14);
    doc.text("Customer Identity & Profile", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Name: ${data.customerProfile?.fullName || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.customerProfile?.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`DOB/Age: ${data.customerProfile?.dobOrAge || 'N/A'}`, 40, yPos);
    doc.text(`Declared Income: ${data.customerProfile?.declaredIncome || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Address: ${data.customerProfile?.address || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Credit Score Summary
    doc.setFontSize(14);
    doc.text("Credit Score Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Score: ${data.creditScoreSummary?.latestScore || 'N/A'}`, 40, yPos);
    doc.text(`Bureau: ${data.creditScoreSummary?.bureau || 'N/A'}`, 150, yPos);
    doc.text(`Band: ${data.creditScoreSummary?.band || 'N/A'}`, 250, yPos);
    doc.text(`Trend: ${data.creditScoreSummary?.trend || 'N/A'}`, 350, yPos);
    yPos += 30;

    // Aggregate Calculations
    doc.setFontSize(14);
    doc.text("Loan Summary Totals", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Total Sanctioned: ${data.aggregateCalculations?.totalSanctionedLoan || 'N/A'}`, 40, yPos);
    doc.text(`Total Outstanding: ${data.aggregateCalculations?.totalOutstandingBalance || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Total EMI: ${data.aggregateCalculations?.totalMonthlyEMI || 'N/A'}`, 40, yPos);
    doc.text(`Avg Interest Rate: ${data.aggregateCalculations?.averageInterestRate || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Avg EMI per Loan: ${data.aggregateCalculations?.averageEMIPerLoan || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Credit Card Summary
    doc.setFontSize(14);
    doc.text("Credit Card Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Limit: ${data.creditCardSummary?.limit || 'N/A'}`, 40, yPos);
    doc.text(`Usage: ${data.creditCardSummary?.usage || 'N/A'}`, 200, yPos);
    doc.text(`Utilization: ${data.creditCardSummary?.utilizationPercent || 'N/A'}`, 350, yPos);
    yPos += 15;
    doc.text(`EMI on Card: ${data.creditCardSummary?.emiOnCard || 'N/A'}`, 40, yPos);
    doc.text(`DPD: ${data.creditCardSummary?.dpd || 'N/A'}`, 200, yPos);
    yPos += 30;

    // Repayment Behaviour & Risk Flags
    doc.setFontSize(14);
    doc.text("Repayment Behaviour & Risk Flags", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`DPD Buckets: ${data.repaymentRedFlags?.dpdBuckets || 'None'}`, 40, yPos);
    doc.text(`Write-offs/Settlements: ${data.repaymentRedFlags?.writeOffs || data.repaymentRedFlags?.settlements || 'No'}`, 300, yPos);
    yPos += 15;
    doc.text(`Overdues: ${data.repaymentRedFlags?.overdues || 'No'}`, 40, yPos);
    doc.text(`Legal Suit Filed: ${data.repaymentRedFlags?.legalSuitFiled || 'No'}`, 300, yPos);
    yPos += 15;
    doc.text(`Restructured Loans: ${data.repaymentRedFlags?.restructuredLoans || 'No'}`, 40, yPos);
    doc.text(`Re-aging: ${data.repaymentRedFlags?.reaging || 'No'}`, 300, yPos);
    yPos += 15;
    doc.text(`Enquiry Count (6M): ${data.repaymentRedFlags?.enquiryCountLast6Months || '0'}`, 40, yPos);
    yPos += 30;

    // Financial Strength Indicators
    doc.setFontSize(14);
    doc.text("Financial Strength Indicators", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`EMI-to-Income Ratio: ${data.financialStrengthIndicators?.emiToIncomeRatio || 'N/A'}%`, 40, yPos);
    doc.text(`Repayment Track: ${data.financialStrengthIndicators?.repaymentTrack || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Total Active Exposure: Rs ${data.financialStrengthIndicators?.totalActiveExposure || 'N/A'}`, 40, yPos);
    doc.text(`Utilization Risk Level: ${data.financialStrengthIndicators?.utilizationRiskLevel || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Secured to Unsecured Ratio: ${data.financialStrengthIndicators?.securedToUnsecuredRatio || 'N/A'}`, 40, yPos);
    doc.text(`Enquiry Behavior: ${data.financialStrengthIndicators?.enquiryBehavior || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Compliance & Regulatory Check
    doc.setFontSize(14);
    doc.text("Compliance & Regulatory Check", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Penal Interest > 3%: ${data.complianceRegulatory?.penalInterest || 'No'}`, 40, yPos);
    doc.text(`RBI Fair Practices Violation: ${data.complianceRegulatory?.rbiFairPracticesViolation || 'No'}`, 300, yPos);
    yPos += 15;
    doc.text(`Re-aging/Rollovers: ${data.complianceRegulatory?.reAgingRollovers || 'No'}`, 40, yPos);
    doc.text(`Legal Dispute: ${data.complianceRegulatory?.legalDispute || 'No'}`, 300, yPos);
    yPos += 15;
    doc.text(`Write-off Reporting: ${data.complianceRegulatory?.writeOffReporting || 'No'}`, 40, yPos);
    yPos += 30;

    // Final Credit Analyst Verdict
    doc.setFontSize(14);
    doc.text("Final Credit Analyst Verdict", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Eligibility: ${data.finalVerdict?.eligibility || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Reasons: ${data.finalVerdict?.reasons || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Corrective Actions: ${data.finalVerdict?.correctiveActions || 'N/A'}`, 40, yPos);
    yPos += 15;
    doc.text(`Missing Documents: ${data.finalVerdict?.missingDocuments || 'None specified'}`, 40, yPos);

    doc.save("credit-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const CreditAnalysisReport = ({ analysisResult }) => {
  const data = analysisResult?.openAIResponse || {};

  return (
    <div className="bg-[#131313] min-h-screen text-white p-6 space-y-6 text-sm font-medium">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Credit Report Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Customer Profile */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🧾 Customer Identity & Profile
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Name</strong>
            <span className="text-white">
              {data.customerProfile?.fullName || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN Card</strong>
            <span className="text-white">
              {data.customerProfile?.pan || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Date of Birth / Age</strong>
            <span className="text-white">
              {data.customerProfile?.dobOrAge || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Address</strong>
            <span className="text-white">
              {data.customerProfile?.address || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Declared Income</strong>
            <span className="text-white">
              {data.customerProfile?.declaredIncome || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Credit Score */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📊 Credit Score Summary
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-2 text-center">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Credit Score</strong>
            <span className="text-white">
              {data.creditScoreSummary?.latestScore || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Bureau</strong>
            <span className="text-white">
              {data.creditScoreSummary?.bureau || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Band</strong>
            <span className="text-white">
              {data.creditScoreSummary?.band || "N/A"}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Trend</strong>
            <span className="text-white">
              {data.creditScoreSummary?.trend || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Active Loan Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💼 Active Loan Account Summary
        </h2>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left mt-3 text-sm border-collapse min-w-[800px]">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th className="border-none">Lender</th>
                <th className="border-none">Type</th>
                <th className="border-none">Sanctioned</th>
                <th className="border-none">Outstanding</th>
                <th className="border-none">EMI</th>
                <th className="border-none">Interest</th>
                <th className="border-none">Tenure</th>
                <th className="border-none">Secured</th>
                <th className="border-none">DPD</th>
              </tr>
            </thead>
            <tbody className="text-white">
              {data.loanAccountSummary?.map((loan, index) => (
                <tr key={index}>
                  <td className="border-none">{loan.bank || "N/A"}</td>
                  <td className="border-none">{loan.loanType || "N/A"}</td>
                  <td className="border-none">
                    {loan.sanctionedAmount || "N/A"}
                  </td>
                  <td className="border-none">
                    {loan.outstandingAmount || "N/A"}
                  </td>
                  <td className="border-none">{loan.emi || "N/A"}</td>
                  <td className="border-none">{loan.interestRate || "N/A"}</td>
                  <td className="border-none">{loan.tenureMonths || "N/A"}</td>
                  <td className="border-none">
                    {loan.securedOrUnsecured || "N/A"}
                  </td>
                  <td className="border-none">{loan.averageDPD || "N/A"}</td>
                </tr>
              )) || (
                <tr>
                  <td
                    colSpan="9"
                    className="border-none text-center text-gray-400"
                  >
                    No active loans found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* total outputs */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-4 text-center">
          <div>
            <strong className="text-[#AAAAAA]">Total Sanctioned</strong>
            <br />
            <span className="text-white text-base">
              {data.aggregateCalculations?.totalSanctionedLoan || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Total Outstanding</strong>
            <br />
            <span className="text-white text-base">
              {data.aggregateCalculations?.totalOutstandingBalance || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Total EMI</strong>
            <br />
            <span className="text-white text-base">
              {data.aggregateCalculations?.totalMonthlyEMI || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Avg Interest Rate</strong>
            <br />
            <span className="text-white text-base">
              {data.aggregateCalculations?.averageInterestRate || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Avg EMI per Loan</strong>
            <br />
            <span className="text-white text-base">
              {data.aggregateCalculations?.averageEMIPerLoan || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Credit Card Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          💳 Credit Card Account Summary
        </h2>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left mt-3 text-sm min-w-[600px]">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th>Lender</th>
                <th>Limit</th>
                <th>Usage</th>
                <th>Utilization</th>
                <th>EMI</th>
                <th>Status</th>
                <th>DPD</th>
              </tr>
            </thead>
            <tbody className="text-white">
              <tr>
                <td>Credit Card</td>
                <td>{data.creditCardSummary?.limit || "N/A"}</td>
                <td>{data.creditCardSummary?.usage || "N/A"}</td>
                <td>{data.creditCardSummary?.utilizationPercent || "N/A"}</td>
                <td>{data.creditCardSummary?.emiOnCard || "N/A"}</td>
                <td>Active</td>
                <td>{data.creditCardSummary?.dpd || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>
        {/* total outputs */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4 text-center">
          <div>
            <strong className="text-[#AAAAAA]">Total Credit Limit</strong>
            <br />
            <span className="text-white text-base">
              {data.creditCardSummary?.limit || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Usage</strong>
            <br />
            <span className="text-white text-base">
              {data.creditCardSummary?.usage || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Utilization</strong>
            <br />
            <span className="text-white text-base">
              {data.creditCardSummary?.utilizationPercent || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Closed Loan Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📁 Closed Loan Account Summary
        </h2>

        <div className="mt-4 overflow-x-auto">
          <div className="min-w-[600px] grid grid-cols-4 sm:grid-cols-4 gap-y-3 gap-x-8 text-sm">
            {/* Header Row */}
            <div className="text-[#AAAAAA] font-medium">Lender</div>
            <div className="text-[#AAAAAA] font-medium">Type</div>
            <div className="text-[#AAAAAA] font-medium">Closed on</div>
            <div className="text-[#AAAAAA] font-medium">DPD</div>

            {/* Data Row */}
            <React.Fragment>
              <div className="text-gray-400 col-span-4 text-center">
                No closed loans data available
              </div>
            </React.Fragment>
          </div>
        </div>
      </div>

      {/* Enquiry History */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📥 Enquiry History (3–6 months)
        </h2>

        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left mt-3 text-sm border-separate border-spacing-y-2 min-w-[600px]">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th>Date</th>
                <th>Institution</th>
                <th>Type</th>
                <th>Amount</th>
                <th>Enquiry Type</th>
                <th>Result</th>
              </tr>
            </thead>

            <tbody className="text-white">
              <tr>
                <td colSpan="6" className="text-center text-gray-400">
                  {data.repaymentRedFlags?.enquiryCountLast6Months || "0"}{" "}
                  enquiries in last 6 months
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Repayment Behavior */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
          <h2 className="text-yellow-400 text-lg font-semibold">
            💡 Repayment Behaviour & Risk Flags
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-3 gap-x-6 mt-4 text-sm">
            {/* Row 1 */}
            <div className="text-[#AAAAAA]">DPD 30–59 Days</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.dpdBuckets || "No DPD issues"}
            </div>
            <div className="text-[#AAAAAA]">Written-off / Settled Accounts</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.writeOffs ||
                data.repaymentRedFlags?.settlements ||
                "No"}
            </div>

            {/* Row 2 */}
            <div className="text-[#AAAAAA]">Total Overdues</div>
            <div className="text-yellow-500">
              {data.repaymentRedFlags?.overdues || "No"}
            </div>
            <div className="text-[#AAAAAA]">Legal Suits / Cases Filed</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.legalSuitFiled || "No"}
            </div>

            {/* Row 3 */}
            <div className="text-[#AAAAAA]">Restructured Loans</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.restructuredLoans || "No"}
            </div>
            <div className="text-[#AAAAAA]">Re-aging</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.reaging || "No"}
            </div>

            {/* Row 4 */}
            <div className="text-[#AAAAAA]">Enquiry Count (6M)</div>
            <div className="text-green-500">
              {data.repaymentRedFlags?.enquiryCountLast6Months || "0"}
            </div>
          </div>
        </div>
      </div>

      {/* Secured Loan / Collateral */}

      <div className="bg-[#1f1f1f] rounded-lg p-4">
        <h2 className="text-yellow-400 text-lg font-semibold">
          🔐 Secured Loan / Collateral Check
        </h2>

        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full text-left mt-4 text-sm border-separate border-spacing-y-2 min-w-[700px]">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th>Lender</th>
                <th>Type</th>
                <th>Collateral</th>
                <th>Market Value</th>
                <th>Loan Amount</th>
                <th>LTV</th>
                <th>Verified</th>
              </tr>
            </thead>
            <tbody className="text-white">
              {data.securedLoanCollateral?.map((loan, index) => (
                <tr key={index}>
                  <td>{loan.lender}</td>
                  <td>{loan.type}</td>
                  <td>{loan.collateral}</td>
                  <td>₹{loan.marketValue?.toLocaleString("en-IN")}</td>
                  <td>₹{loan.loanAmount?.toLocaleString("en-IN")}</td>
                  <td
                    className={
                      loan.ltv > 90
                        ? "text-red-500 font-medium"
                        : loan.ltv > 80
                        ? "text-yellow-400 font-medium"
                        : "text-green-500 font-medium"
                    }
                  >
                    {loan.ltv}%
                  </td>
                  <td
                    className={
                      loan.verified === "Yes"
                        ? "text-green-500 font-medium"
                        : "text-yellow-400 font-medium"
                    }
                  >
                    {loan.verified}
                  </td>
                </tr>
              )) || (
                <tr>
                  <td colSpan="7" className="text-center text-gray-400">
                    No secured loans found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Compliance & Regulatory */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          ✔️ Compliance & Regulatory Check
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 mt-4 text-sm">
          <div className="space-y-3">
            {/* Row 1 */}
            <div className="grid grid-cols-2 gap-x-4">
              <div className="text-[#AAAAAA]">
                Penal Interest &gt; 3% (RBI capped)
              </div>
              <div className="text-green-500">
                {data.complianceRegulatory?.penalInterest || "No"}
              </div>
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-2 gap-x-4">
              <div className="text-[#AAAAAA]">
                RBI Fair Practices Violation Flag
              </div>
              <div className="text-green-500">
                {data.complianceRegulatory?.rbiFairPracticesViolation || "No"}
              </div>
            </div>

            {/* Row 3 */}
            <div className="grid grid-cols-2 gap-x-4">
              <div className="text-[#AAAAAA]">
                Re-aging / Rollovers Observed
              </div>
              <div className="text-yellow-400">
                {data.complianceRegulatory?.reAgingRollovers || "No"}
              </div>
            </div>

            {/* Row 4 - Mobile only */}
            <div className="grid grid-cols-2 gap-x-4 sm:hidden">
              <div className="text-[#AAAAAA]">Legal Dispute / Suit Filed</div>
              <div className="text-green-500">No</div>
            </div>

            {/* Row 5 - Mobile only */}
            <div className="grid grid-cols-2 gap-x-4 sm:hidden">
              <div className="text-[#AAAAAA]">Any Write-off Reporting</div>
              <div className="text-green-500">No</div>
            </div>
          </div>

          <div className="space-y-3 hidden sm:block">
            {/* Row 4 - Large screens */}
            <div className="grid grid-cols-2 gap-x-4">
              <div className="text-[#AAAAAA]">Legal Dispute / Suit Filed</div>
              <div className="text-green-500">
                {data.complianceRegulatory?.legalDispute || "No"}
              </div>
            </div>

            {/* Row 5 - Large screens */}
            <div className="grid grid-cols-2 gap-x-4">
              <div className="text-[#AAAAAA]">Any Write-off Reporting</div>
              <div className="text-green-500">
                {data.complianceRegulatory?.writeOffReporting || "No"}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Financial Strength */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-base font-semibold flex items-center mb-3">
          🏦 Financial Strength Indicators (Derived)
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4 text-sm text-white">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-400">EMI-to-Income Ratio</span>
              <span className="text-green-400 font-medium">
                {data.financialStrengthIndicators?.emiToIncomeRatio || "N/A"}%
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Repayment Track</span>
              <span className="text-green-400 font-medium">
                {data.financialStrengthIndicators?.repaymentTrack || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Total Active Exposure</span>
              <span className="text-white font-medium">
                ₹
                {data.financialStrengthIndicators?.totalActiveExposure?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Utilization Risk Level</span>
              <span className="text-yellow-400 font-medium">
                {data.financialStrengthIndicators?.utilizationRiskLevel ||
                  "N/A"}
              </span>
            </div>

            {/* Mobile only - remaining items */}
            <div className="flex justify-between sm:hidden">
              <span className="text-gray-400">Secured to Unsecured Ratio</span>
              <span className="text-white font-medium">5:1</span>
            </div>
            <div className="flex justify-between sm:hidden">
              <span className="text-gray-400">Enquiry Behavior</span>
              <span className="text-green-400 font-medium">Normal</span>
            </div>
            <div className="flex justify-between sm:hidden">
              <span className="text-gray-400">Average EMI per Account</span>
              <span className="text-white font-medium">₹5,500</span>
            </div>
          </div>

          <div className="space-y-3 hidden sm:block">
            <div className="flex justify-between">
              <span className="text-gray-400">Secured to Unsecured Ratio</span>
              <span className="text-white font-medium">
                {data.financialStrengthIndicators?.securedToUnsecuredRatio ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Enquiry Behavior</span>
              <span className="text-green-400 font-medium">
                {data.financialStrengthIndicators?.enquiryBehavior || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-400">Average EMI per Account</span>
              <span className="text-white font-medium">
                ₹
                {data.financialStrengthIndicators?.averageEMIPerAccount?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Final Verdict */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📌 Final Credit Analyst Verdict
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-4">
          <div>
            <strong>Eligibility</strong>
            <br />
            <span className="text-green-500">
              {data.finalVerdict?.eligibility || "N/A"}
            </span>
          </div>
          <div>
            <strong>Reasons</strong>
            <br />
            <span className="text-white text-sm">
              {data.finalVerdict?.reasons || "N/A"}
            </span>
          </div>
          <div>
            <strong>Corrective Actions</strong>
            <br />
            <span className="text-yellow-400 text-sm">
              {data.finalVerdict?.correctiveActions || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Red Flags */}
      <div className="bg-[#300d0d] rounded-lg p-4 border border-red-700 text-red-400 space-y-2">
        <h2 className="font-semibold text-red-500">⚠️ Red Flags to Address</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            {data.finalVerdict?.correctiveActions ||
              "No specific red flags identified"}
          </li>
          <li>
            Missing Documents:{" "}
            {data.finalVerdict?.missingDocuments || "None specified"}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CreditAnalysisReport;
